<template>
    <div class="modal-vue-container" v-show="show">
        <div :class="modalStyle"  role="document">
            <slot name="content"></slot>
        </div><!-- /.modal-dialog -->
    </div>
</template>
<script>
    export default {
        name: "modal-styless",
        props: {
            show: {
                required:true,
                type: Boolean
            },
            modalStyle:{
                type: String,
                default:''
            },
            id:{
                type: String,
                default:''
            },
        }
    }
</script>
<style scoped>
    .modal-vue-wrapper {
        position: fixed;
        z-index: 1050;
        outline: 0;
    }
    .modal-vue-container {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s ease;
    }
</style>